/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Info_Batch_Selected_CountInputs */

const en_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} projects selected`)
};

const fr_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projets ${i?.count} sélectionnés`)
};

const de_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählte Projekte`)
};

const it_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progetti selezionati ${i?.count}`)
};

const ru_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`отобранные проекты ${i?.count}`)
};

const es_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proyectos ${i?.count} seleccionados`)
};

const zh_cn2_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已选择 ${i?.count} 项目`)
};

const ja_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} プロジェクトが選択されました`)
};

const hi_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चयनित परियोजनाएँ ${i?.count}`)
};

const pt_pt2_explorer_info_batch_selected_count = /** @type {(inputs: Explorer_Info_Batch_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projetos ${i?.count} selecionados`)
};

/**
* | output |
* | --- |
* | "{count} projects selected" |
*
* @param {Explorer_Info_Batch_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_selected_count = /** @type {((inputs: Explorer_Info_Batch_Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_selected_count(inputs)
	if (locale === "de") return de_explorer_info_batch_selected_count(inputs)
	if (locale === "it") return it_explorer_info_batch_selected_count(inputs)
	if (locale === "ru") return ru_explorer_info_batch_selected_count(inputs)
	if (locale === "es") return es_explorer_info_batch_selected_count(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_selected_count(inputs)
	if (locale === "ja") return ja_explorer_info_batch_selected_count(inputs)
	if (locale === "hi") return hi_explorer_info_batch_selected_count(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_selected_count(inputs)
	return en_explorer_info_batch_selected_count(inputs)
});